// Global Instructions Rule Applied!
//
// Merge fields the dispatch edge function substitutes in subject + body.
// Click-to-copy chip strip in the Compose tab makes the placeholder syntax
// + behavior discoverable; the template editor reuses the same list so the
// authoring surfaces stay consistent.
//
// Keep this list in lockstep with the edge fn's substituteMergeFields keys
// (buildIndividualPrepared + buildTeamPrepared in
// supabase/functions/email-dispatch/index.ts).

export interface MergeField {
  placeholder: string
  tooltip: string
}

export const MERGE_FIELDS: MergeField[] = [
  {
    placeholder: '{{first_name}}',
    tooltip:
      'Recipient first name. Individual mode: the contact’s first name. Team mode: empty (no single contact — use {{team_name}} or {{first_names_list}} for the greeting).'
  },
  {
    placeholder: '{{team_name}}',
    tooltip:
      'accounts.team_name (falls back to accounts.name when blank). The natural greeting in team mode; in individual mode it’s the recipient’s account team name.'
  },
  {
    placeholder: '{{first_names_list}}',
    tooltip:
      'Team mode: comma-joined first names of To recipients (e.g. "Alice, Bob"). Individual mode: the single contact’s first name.'
  },
  {
    placeholder: '{{account_name}}',
    tooltip: 'The recipient’s account name.'
  },
  {
    placeholder: '{{last_name}}',
    tooltip: 'Recipient last name. Individual mode only (empty in team mode).'
  },
  {
    placeholder: '{{email}}',
    tooltip: 'Recipient email address. Individual mode only (empty in team mode).'
  }
]

// Deal merge fields for STAGE-ACTION notification emails (Configuration →
// Stage Actions). Substituted by the backend stage_actions processor, not the
// dispatch edge fn. Keep this list in lockstep with the jsonb keys of
// stage_action__deal_merge_data
// (backend/src/data_manager/rpc_functions/function_stage_action__deal_merge_data.sql).
export const DEAL_MERGE_FIELDS: MergeField[] = [
  { placeholder: '{{deal.name}}', tooltip: 'The deal name.' },
  { placeholder: '{{deal.type}}', tooltip: 'The deal type (e.g. Subscription).' },
  { placeholder: '{{deal.stage}}', tooltip: 'The stage the deal just entered (e.g. Committed).' },
  { placeholder: '{{deal.stage_date}}', tooltip: 'The date the deal entered the stage (e.g. 24 Jul 2026).' },
  { placeholder: '{{deal.currency}}', tooltip: 'The deal currency code (e.g. USD).' },
  { placeholder: '{{deal.commitment_amount}}', tooltip: 'The committed amount, formatted with thousands separators.' },
  { placeholder: '{{deal.allocation_available}}', tooltip: 'The available allocation, formatted with thousands separators.' },
  { placeholder: '{{pipeline.name}}', tooltip: 'The pipeline the stage belongs to (e.g. Early Stage).' },
  { placeholder: '{{account.name}}', tooltip: 'The deal’s account (company) name.' },
  { placeholder: '{{account.website}}', tooltip: 'The account website URL.' },
  { placeholder: '{{account.industry}}', tooltip: 'The account industry.' },
  { placeholder: '{{round.name}}', tooltip: 'The linked funding round name (empty when the deal has no round).' },
  { placeholder: '{{round.raise_amount}}', tooltip: 'The round raise amount, formatted.' },
  { placeholder: '{{round.pre_money_valuation}}', tooltip: 'The round pre-money valuation, formatted.' },
  { placeholder: '{{round.post_money_valuation}}', tooltip: 'The round post-money valuation, formatted.' }
]
